/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_Legal_FooterInputs */

const cs_builder_block_legal_footer = /** @type {(inputs: Builder_Block_Legal_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právní / patička agentury`)
};

const en_builder_block_legal_footer = /** @type {(inputs: Builder_Block_Legal_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal / agency footer`)
};

/**
* | output |
* | --- |
* | "Legal / agency footer" |
*
* @param {Builder_Block_Legal_FooterInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_legal_footer = /** @type {((inputs?: Builder_Block_Legal_FooterInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_Legal_FooterInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_legal_footer(inputs)
	return cs_builder_block_legal_footer(inputs)
});